import React from 'react';
import seo from '../../images/modules/seo.svg';
import content from '../../images/modules/content.svg';
import paidMedia from '../../images/modules/paidMedia.svg';

export const SeoIcon = () => (
  <div style={{ justifyItems: 'center', display: 'flex', justifyContent: 'center' }}>
    <img src={seo} alt="SEO Icon" width={24} height={24} />
  </div>
);
export const ContentIcon = () => (
  <div style={{ justifyItems: 'center', display: 'flex', justifyContent: 'center' }}>
    <img src={content} alt="Content Icon" width={24} height={24} />
  </div>
);
export const PaidMediaIcon = () => (
  <div style={{ justifyItems: 'center', display: 'flex', justifyContent: 'center' }}>
    <img src={paidMedia} alt="Paid Media Icon" width={24} height={24} />
  </div>
);
